import { issueFieldTask, IssueStrategy } from './handlersIndex';

interface IssueArgs {
  overlayFields: any[];
  mergedFields: Record<string, any>;
  formRecord: any;
  navigateTo: string;
  formNum?: string;
  formDesc?: string;
  strategy?: IssueStrategy; // 'parallel' | 'sequential'
}

// Iterate fields and delegate to registered handlers.
// For sequential strategy, sequence increments only for fields that produce tasks (e.g., unsigned signatures).
export async function issueTasksForForm(args: IssueArgs): Promise<number> {
  const {
    overlayFields = [],
    mergedFields = {},
    formRecord,
    navigateTo,
    formNum,
    formDesc,
    strategy = 'parallel',
  } = args;

  let seqCounter = 1;
  let createdCount = 0;
  for (const fieldDef of (Array.isArray(overlayFields) ? overlayFields : [])) {
    const type = String(fieldDef?.type || '').toLowerCase();

    // Prepare context
    const ctx: any = {
      formRecord,
      mergedFields,
      fieldDef,
      navigateTo,
      formNum,
      formDesc,
      strategy,
      sequence: seqCounter,
    };

    // Attempt issuing for this field; if a task is created (sequential), bump sequence
    const created = await issueFieldTask(ctx);
    if (created) {
      createdCount += 1;
    }
    if (strategy === 'sequential' && created) {
      seqCounter += 1;
    }
  }
  return createdCount;
}
